import { Flow, Text as Tx, } from "@bracket/ui";
import styled from "styled-components";
import type { FunctionComponent, } from "react";


export declare type FieldDescriptionProps = {
  title: string;
  description?: string;
};

export const FieldDescription: FunctionComponent<FieldDescriptionProps> = ({
  title,
  description,
}) => {

	return (
    <Container>
      <Tx md color="heading">{title}</Tx>
      { description && (<Tx xsm color="subheading">{description}</Tx>) }
    </Container>
  );

};


const Container = styled(Flow)`
`;
